import {useRouter} from "next/router";
import CustomHeader from "./CustomDatePicker/CustomHeader";
import DatePicker from "react-datepicker";
import {ExampleCustomInput} from "./ImmobilieMieten";
import {useTranslation} from "next-i18next";
import {ScreenNumber, useMediaQuery} from "../../hooks/useMediaQuery";
import {forwardRef, useState} from "react";
import IconCalender from "../../data/Icons/leon-inmobiliaria-icons-kalender.svg";
import "react-datepicker/dist/react-datepicker.css";

interface AnreiseSelectPropsInterface {
	onStartDateChange: (date: Date | null) => void;
	onEndDateChange: (date: Date | null) => void;
	startDate?: Date | null;
	endDate?: Date | null;
}

export default function AnreiseSelect(props: AnreiseSelectPropsInterface) {
	const [openDatePicker, setOpenDatePicker] = useState<boolean>();
	const ExampleCustomInputFrom = forwardRef(
		({value, onClick}: any, ref): any => {

			return (
				<button
					type="button"
					className="w-full border-none input-field flex justify-between items-center p-2 h-[40px] shadow-none gap-1 text-[12px] lg:text-base"
					onClick={() => {
						onClick;
						!openDatePicker && setOpenDatePicker(undefined);
						openDatePicker === undefined && setOpenDatePicker(true);
					}}
					ref={ref as any}
				>
					{value.toString().split("-")[0]}
					<IconCalender className="w-3 lg:w-5"/>
				</button>
			);
		}
	);
	ExampleCustomInputFrom.displayName = "ExampleCustomInput";

	const router = useRouter();
	const {t} = useTranslation();
	const {currentScreenAsNumber} = useMediaQuery();

	const onDateRangeChange = (dates: [Date | null, Date | null]) => {
		const [start, end] = dates;
		props.onStartDateChange(start);
		props.onEndDateChange(end);
		if (start && end) {
			setOpenDatePicker(false);
		}
	};

	return (
		<>
			<label className="shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)] flex items-center px-1 md:px-2 md:min-w-[128px]">
				<DatePicker
					open={openDatePicker}
					dateFormat="dd.MM.yyyy"
					filterDate={(date) => (Boolean(props.startDate) === true && Boolean(props.endDate) !== true) || date.getDay() !== 0}
					selected={props.startDate}
					onChange={(dates) => {
						onDateRangeChange(dates);
					}}
					calendarClassName="!border-none p-7 md:p-10 !flex md:!text-lg !font-sans md:!text-[18px] !tracking-[2.7px]"
					renderCustomHeader={(props) => (
						<>
							<CustomHeader
								twoMonth={currentScreenAsNumber > ScreenNumber.lg}
								{...props}
							/>
						</>
					)}
					startDate={props.startDate}
					endDate={props.endDate}
					renderDayContents={(day, date) => (
						<div className="flex-1 ">
							<p className="font-normal lg:!text-[18px]">{day}</p>
						</div>
					)}
					selectsRange
					calendarStartDay={1}
					customInput={<ExampleCustomInputFrom/>}
					locale={router.locale}
					showPopperArrow={false}
					monthsShown={currentScreenAsNumber > ScreenNumber.lg ? 2 : 1}
					disabledKeyboardNavigation
					minDate={new Date()}
					onClickOutside={() => setOpenDatePicker(undefined)}
				/>
				{!props.startDate && (
					<span className="text-[12px] md:text-[16px] text-[#85888c]">
						{t("components.anreiseSelect.arrival")}
					</span>
				)}
			</label>
		</>
	);
}
